const header = {
  init: function () {
    const html = document.querySelector("html");
    const toggle = document.querySelector("#mdbio_menu_btn_toggle");
    const toggle1 = document.querySelector("#mdbio_menu_btn_toggle1"); // Add this line
    const overlay = document.querySelector("#mdbio__overlay");
    const closeBtns = document.querySelectorAll(".header-cross");

    const closeMenu = () => {
      html.dataset["menu_open"] = "false";
    };

    toggle.addEventListener("click", () => {
      html.dataset["menu_open"] = "true";
    });

    if (toggle1) { // Check if toggle1 exists
      toggle1.addEventListener("click", () => { // Use toggle1 if it exists
        html.dataset["menu_open"] = "true";
      });
    }

    overlay.addEventListener("click", closeMenu);

    for (let i = 0; i < closeBtns.length; i++) {
      closeBtns[i].addEventListener("click", closeMenu);
    }
  },
};

(() => {
  header.init();
})();
